import React from 'react';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';

import WarningIcon from 'assets/warning_outlined.svg?react';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';

interface ShowCropSeasonConfirmModalProps {
  onOk: () => any;
  onCancel?: () => void;
}

const showCropSeasonConfirmModal = ({
  onOk,
  onCancel
}: ShowCropSeasonConfirmModalProps) => {
  Modal.confirm({
    icon: (
      <span className="flex items-center" style={{ gap: 12 }}>
        <span className="flex items-center">
          <WarningIcon width={24} height={24} style={{ color: '#E99921' }} />
        </span>
        <span
          className="font-semibold"
          style={{ fontSize: 18, color: '#14151C' }}
        >
          {LayoutStrings.modal.cropSeasonSelectTitle}
        </span>
      </span>
    ),
    content: (
      <span className="ml-10">
        {LayoutStrings.modal.cropSeasonSelectContent}
      </span>
    ),
    okText: LayoutStrings.buttons.changeSeason,
    cancelText: LayoutStrings.buttons.goBack,
    centered: true,
    closable: false,
    maskClosable: false,
    transitionName: '',
    maskTransitionName: '',
    width: 423,
    okButtonProps: {
      style: {
        background: 'var(--Green-green-60, #14803C)',
        color: 'var(--Neutral-neutral-00, #FFF)',
        marginLeft: 8,
        padding: '10px 16px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 400
      }
    },
    cancelButtonProps: {
      style: {
        background: 'var(--Neutral-neutral-00, #FFF)',
        color: 'var(--Neutral-neutral-100, #14151C)',
        marginRight: 0,
        padding: '10px 16px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 400,
        border: '1px solid var(--Neutral-neutral-30, #C2C7D0)'
      }
    },
    onOk,
    onCancel
  });
};

export default showCropSeasonConfirmModal;
